import { createAction, props } from '@ngrx/store';
import { FarmCadastralSheet } from '../_models';

// Action types
export const loadFarmCadastralSheets = createAction(
  '[FarmCadastralSheet] Load Farm Cadastral Sheets'
);
export const loadFarmCadastralSheetsSuccess = createAction(
  '[FarmCadastralSheet] Load Farm Cadastral Sheets Success',
  props<{ farmCadastralSheets: FarmCadastralSheet[] }>()
);
export const loadFarmCadastralSheetsFailure = createAction(
  '[FarmCadastralSheet] Load Farm Cadastral Sheets Failure',
  props<{ error: any }>()
);

export const addFarmCadastralSheet = createAction(
  '[FarmCadastralSheet] Add Farm Cadastral Sheet',
  props<{ farmCadastralSheet: FarmCadastralSheet }>()
);
export const addFarmCadastralSheetSuccess = createAction(
  '[FarmCadastralSheet] Add Farm Cadastral Sheet Success',
  props<{ farmCadastralSheet: FarmCadastralSheet }>()
);
export const addFarmCadastralSheetFailure = createAction(
  '[FarmCadastralSheet] Add Farm Cadastral Sheet Failure',
  props<{ error: any }>()
);

export const updateFarmCadastralSheet = createAction(
  '[FarmCadastralSheet] Update Farm Cadastral Sheet',
  props<{ farmCadastralSheet: FarmCadastralSheet }>()
);
export const updateFarmCadastralSheetSuccess = createAction(
  '[FarmCadastralSheet] Update Farm Cadastral Sheet Success',
  props<{ farmCadastralSheet: FarmCadastralSheet }>()
);
export const updateFarmCadastralSheetFailure = createAction(
  '[FarmCadastralSheet] Update Farm Cadastral Sheet Failure',
  props<{ error: any }>()
);

export const deleteFarmCadastralSheet = createAction(
  '[FarmCadastralSheet] Delete Farm Cadastral Sheet',
  props<{ id: number }>()
);
export const deleteFarmCadastralSheetSuccess = createAction(
  '[FarmCadastralSheet] Delete Farm Cadastral Sheet Success',
  props<{ id: number }>()
);
export const deleteFarmCadastralSheetFailure = createAction(
  '[FarmCadastralSheet] Delete Farm Cadastral Sheet Failure',
  props<{ error: any }>()
);
